module.exports = __webpack_public_path__ + "img/dobozragasztas-thumb.2e7a8312.jpg";